import { t } from 'i18next'

import CreditCardSection from '../sections/CreditCardSection'
import MarketplaceSection from '../sections/MarketplaceSection'
import PixSection from '../sections/PixSection'
import MarketplaceOptionLabel from './MarketplaceOptionLabel'

export const methodComponents = {
  marketplace: MarketplaceSection,
  pix: PixSection,
  credit_card: CreditCardSection
}

export const methodOptions: MethodOptions = {
  marketplace: props => ({
    value: 'marketplace',
    label: <MarketplaceOptionLabel />,
    description: t('rm:marketplace.radio.description'),
    disabled: props?.disabled ?? false,
    activeChildren: <MarketplaceSection />
  }),
  pix: (props?: MethodOptionsProps) => ({
    value: 'pix',
    label: 'PIX',
    description: '',
    disabled: props?.disabled ?? false,
    activeChildren: <PixSection />
  }),
  credit_card: (props?: MethodOptionsProps) => ({
    value: 'credit_card',
    label: t('rm:creditCard'),
    description: '',
    disabled: props?.disabled ?? false,
    activeChildren: <CreditCardSection />
  })
}

const getMethodOptions = ({
  allowedTypes,
  disabledOptions
}: GetMethodOptionProps) => {
  const availableKeys = Object.keys(methodOptions) as PaymentTypes[]

  const filterAllowedTypes = availableKeys.filter(type =>
    allowedTypes?.some(item => item.type === type)
  )

  if (filterAllowedTypes.length === 0) return []

  const checkDisabled = (type: PaymentTypes) =>
    Boolean(disabledOptions?.includes(type))

  return filterAllowedTypes.map(type =>
    methodOptions[type]({
      disabled: checkDisabled(type)
    })
  )
}

export default getMethodOptions
